import { createI18n } from "vue-i18n";
import en from "@/locales/en.json";
import bn from "@/locales/bn.json";
import store from "@/store";

const i18n = createI18n({
    legacy: false,
    locale: store.getters.currentLang || "en",
    fallbackLocale: "en",
    missingWarn: process.env.NODE_ENV === 'development',
    fallbackWarn: false,
    messages: {
        en,
        bn,
    },
});

export default i18n;
